<template>
            <v-container class="" fluid  v-if="!$store.state.authenticated">
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" md="5">
                        <v-card class="elevation-12">
                            <v-toolbar color="primary" dark flat>
                                <v-toolbar-title v-if="(!authFail && !authPassword == '' && !authPassword == null) || 
                                    (authEmail == '' || authEmail == null || authPasswordSended || pw_is_loading || !authFormValid)">Identifez-vous</v-toolbar-title>
                                <v-row align="center" justify="center" v-if="authFail || authPassword == '' || authPassword == null && 
                                        (authEmail != '' && authEmail != null && !authPasswordSended && !pw_is_loading && authFormValid)">
                                    <v-btn color="blue darken-4" @click="authAskPassword(authEmail)">
                                        Demander un mot de passe
                                    </v-btn>
                                </v-row>
                            </v-toolbar>
                            <v-flex v-if="pw_is_loading">
                                <v-progress-linear :indeterminate="true" class="progress" rounded></v-progress-linear>
                            </v-flex>
                            <v-card-text>
                                <v-form v-model="authFormValid">
                                    <v-text-field 
                                        label="E-mail" 
                                        name="email" 
                                        required
                                        prepend-icon="person" 
                                        type="text" 
                                        v-model="authEmail"
                                        :rules="authFormEmailRules">
                                    </v-text-field>
                                    <v-text-field id="password" label="Mot de passe" name="password" prepend-icon="lock" type="password"  
                                        v-model="authPassword" v-on:keyup.enter="authSubmit">
                                    </v-text-field>
                                </v-form>
                                <v-row align="center" justify="center">
                                    <v-chip class="white--text" v-if="authPasswordSended" color="success"><h3>Mot de passe envoyé</h3></v-chip>
                                    <v-chip class="white--text" v-if="authPasswordError" color="error"><h3>Erreur. Impossible d'envoyer l'email.</h3></v-chip>
                                    <v-chip class="white--text" v-if="axios_error !== ''" color="error"><h3>{{ axios_error }} !</h3></v-chip>
                                    <v-chip class="white--text" v-if="authMessage != '' && authMessage != null" color="error"><h3>{{ authMessage }}</h3></v-chip>
                                </v-row>
                            </v-card-text>
                            <v-row align="center" justify="center">
                                <v-card-actions>
                                    <v-btn color="primary" v-if="!authFail && authPassword != '' && authPassword != null && authEmail != '' && authEmail != null" @click="authSubmit">
                                        Login
                                    </v-btn>
                                </v-card-actions>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
</template>
<script>
	import axios from 'axios';

    export default {
		name: 'Authentification',
		data: function () {
			return {
				authEmail: null,
				authPassword: null,
				authPasswordSended: false,
				authPasswordError: false,
				authMessage: null,
				authFail: null,
				authFormValid: false,
				authFormEmailRules: [
					v => !!v || 'E-mail obligatoire',
					v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) || 'E-mail invalide',
				],
				pw_is_loading: false,
				is_loading: false,
				axios_error: '',
			}
		},
		created() {
			axios.interceptors.request.use((config) => {
				this.setLoading(true);
				return config;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
			axios.interceptors.response.use((response) => {
				this.setLoading(false);
				return response;
			}, (error) => {
				this.setLoading(false);
				return Promise.reject(error);
			});
		},
		mounted () {
		},
		methods: {	
			setLoading(is_loading) {			
				if (is_loading) {
					this.is_loading = true;
				} else {
					this.is_loading = false;
				}
			},
			emailValidation (){
				if (!this.email) {
					this.emailValidationText = 'e-mail obligatoire.';
				} else {
					this.emailValidationText = '';
				}
				if (!this.validEmail(this.email)) {
					this.emailValidationText='Veuillez entrer une adresse valide SVP.';
				} else {
					this.emailValidationText = '';
				}
			},
					
			authAskPassword: function(email) {
				this.pw_is_loading = true;
				this.authFail = false;
				var link = 'http://domoserver.ddns.net/gigamedia1/authAskPassword.php?email='+encodeURIComponent(email);
				axios.get(link).then(response => {
					this.authPasswordSended = response.data.mail_sent;
					this.authPasswordError = false;
					this.authPasswordError = !response.data.mail_sent;
					setTimeout(() => {
						this.authPasswordSended = false;
						this.pw_is_loading = false;
					}, 5000);
					this.pw_is_loading = (!response.data.mail_sent && !this.authPasswordError);});
					this.authPasswordError = false;
			},
			authSubmit: function() {
				let formData = new FormData();

					formData.append('email', this.authEmail);
					formData.append('password', this.authPassword);

				/*
					Make the request to the POST /multiple-files URL
				*/
				var link = 'http://domoserver.ddns.net/gigamedia1/authentication.php';
				
				this.axios_error='';

				this.axios.post( link,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
				).then(response => {
					this.$store.state.authenticated = response.data.authenticated;
					this.$store.state.authenticatedAdmin = response.data.admin;
					this.authMessage = response.data.message;
					if(!response.data.authenticated) {
						this.authFail = true;
					}
					setTimeout(() => {
						this.authMessage = null;
						this.authFail = false;
						this.authPassword = null;
					}, 5000);

					this.axios_error = '';
				}).catch((error) => {
					this.axios_error = error;
				})
			},
			getColor (dateValidation) {
				var dateValidationInt = new Date(dateValidation)
				var currentDate = new Date();
				if (dateValidationInt < currentDate) return 'red'
				else return 'green'
			},
		},
	};	
</script>

<style>
	h2 {
		margin: 10px;
	}
	.progress {
		margin-top: 1px;
	}
	.cardWrapper {
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
</style>